<template>
<div>

  <div class="sticky">
    <h5> Effectuer une recherche pour la carte {{currentMap.mapTitle}} </h5>
    <b-input-group prepend="Mots-clés" class="mt-3">
      <b-form-input v-model="keyWords" @keyup.enter="findEuropeanaResults()"></b-form-input>
      <b-input-group-append>
        <b-button variant="success" @click="findEuropeanaResults()">Rechercher</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-alert class="europeanaAlert" v-if="europeanaResponse.itemsCount == 0" show variant="info">Aucun résultat</b-alert>
  </div>
  <div class="europeanaItems">
    <b-card v-for="item in europeanaItems" :key="item.id" :img-src="getImage(item)" img-alt="Image" img-left tag="article" class="mb-2">
      <b-card-title> <a :href="item.guid" target="blank" >{{item.title[0] != undefined ? item.title[0] : 'Pas de titre' }} </a></b-card-title>
      <b-card-text>
        <div id="itemDescription">
          Description: "{{ item.dcDescription != undefined ? item.dcDescription[0] : 'Pas de description' }}"
        </div>
        <b-list-group>
          <b-list-group-item>Créateur: {{item.dcCreator != undefined ? item.dcCreator[0] :  'Inconnu'}}</b-list-group-item>
          <b-list-group-item>Fournisseur: {{item.dataProvider[0] != undefined ? item.dataProvider[0] :  'Inconnu'}}</b-list-group-item>
          <b-list-group-item>Pays: {{item.country != undefined ? item.country[0] :  'Inconnu'}}</b-list-group-item>
        </b-list-group>
      </b-card-text>
      <b-button-group class="mx-1">
      <b-button :href="item.guid" target="blank" variant="primary">Lien Europeana</b-button>
      <b-button v-if="isAuthenticated && !alreadyRegistered(item)" variant="success" @click="addEuropeanaResourceForMap(item)">Ajouter à la carte</b-button>
      </b-button-group>
      <b-alert class="europeanaAlert" v-if="!isAuthenticated" show variant="info">Connectez-vous pour l'ajouter à la carte</b-alert>
      <b-alert class="europeanaAlert" v-if="alreadyRegistered(item)" show variant="warning">La ressource a déjà été enregistrée</b-alert>
    </b-card>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'europeana-search',
  props: ['currentMap'],
  data() {
    return {
      keyWords: '',
      newEuropeanaResource: {
        'ark': '',
        'mapIdentifier': '',
        'username': '',
        'title': '',
        'dcDescription': '',
        'dcCreator': '',
        'dataProvider': '',
        'country': '',
        'edmPreview': ''
      }
    }
  },
  created() {
    this.$store.dispatch('findEuropeanaResourcesForMap', this.currentMap.mapIdentifier)
  },
  computed: {
    ...mapGetters({
      europeanaItems: 'getEuropeanaItems',
      europeanaResponse: 'getEuropeanaResponse',
      isAuthenticated: 'getIsAuthenticated',
      currentUser: 'getCurrentUser',
      europanaResourcesList: 'getEuropanaResourcesList'
    })
  },
  methods: {
    // Vérifie si la ressource a déjà été enregistrée à la carte
    alreadyRegistered: function(item) {
      return this.europanaResourcesList.some(resource => resource.ark == item.guid)
    },
    // Affiche l'image de l'item si elle existe
    getImage: function(item) {
      if (item.edmPreview) {
        return item.edmPreview[0]
      }
    },
    // Envoie la recherche de l'utilisateur au store qui va envoyer la requête HTTP
    findEuropeanaResults: function() {
      this.$store.dispatch('findEuropeanaResults', this.keyWords)
    },
    // Ajout de la ressource Europeana à la carte courante
    addEuropeanaResourceForMap: function(item){
      
      this.newEuropeanaResource.ark = item.guid
      this.newEuropeanaResource.mapIdentifier = this.currentMap.mapIdentifier
      this.newEuropeanaResource.username = this.currentUser.username
      this.newEuropeanaResource.title = item.title != undefined ? item.title[0] : 'Pas de titre'
      this.newEuropeanaResource.dcDescription = item.dcDescription != undefined ? item.dcDescription[0] : 'Pas de description'
      this.newEuropeanaResource.dcCreator = item.dcCreator != undefined ? item.dcCreator[0] : 'Inconnu'
      this.newEuropeanaResource.dataProvider = item.dataProvider[0]
      this.newEuropeanaResource.country = item.country != undefined ? item.country[0] : 'Inconnu'
      this.newEuropeanaResource.edmPreview = item.edmPreview != undefined ? item.edmPreview[0] : 'Pas d\'image'

      this.$store.dispatch('addEuropeanaResourceForMap', this.newEuropeanaResource)
      this.$bvToast.toast('Lien Europeana ajouté', {
        title: `Notification`,
        variant: 'success',
        solid: true
        })
    }
  }
}
</script>

<style>
.sticky {
  position: sticky;
  top: 0px;
  padding: 20px;
  z-index: 99;
  background-color: white;
}

.europeanaItems {
  top: 100px;
}

.europeanaAlert {
margin-top: 10px;
}

#itemDescription {
  text-align: justify;
  text-justify: inter-word;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/search/EuropeanaSearch.vue